import './typography-mapping.css';
export var MarkdownCheckmarkBackgroundCSS = '_11vdepp5-3-5-0';
export var MarkdownHeadingCSS = '_11vdepp0-3-5-0';
export var MarkdownImageCSS = '_11vdepp4-3-5-0';
export var MarkdownListCSS = '_11vdepp1-3-5-0';
export var MarkdownListItemCSS = '_11vdepp2-3-5-0';
export var MarkdownParagraphCSS = '_11vdepp3-3-5-0';